import {z} from 'zod';

import i18n from '@dms/i18n';

export const BasicInformationFormSchema = z.object({
  name: z.string().trim().min(1, i18n.t('general.validations.fieldIsRequired')),
  description: z.string().trim().nullable().optional(),
  materialDiscountGroupId: z.string().nullable().optional(),
});

export type BasicInformationFormType = z.infer<typeof BasicInformationFormSchema>;
